// src/services/NewsService.js
//
// Short announcements with a run of dates.
//
// Two audiences:
//   all_users  - a banner under the header for anyone signed in
//   display    - a strip along the bottom of the hallway screen
//
// An item is "active" when today falls inside its date range, inclusive at both
// ends. Several can be active at once; the display cycles them.
//
// NOTE: any signed-in user can post or delete. Vero has no roles yet.

import apiClient from './apiClient'

export const AUDIENCES = [
  { value: 'all_users', label: 'All users' },
  { value: 'display', label: 'Display' }
]

export function audienceLabel(value) {
  return AUDIENCES.find((a) => a.value === value)?.label ?? value
}

export async function getNews() {
  const response = await apiClient.post('/GetNews', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read news')
  }
  return response.data.news ?? []
}

export async function getActiveNews(audience = 'display') {
  const response = await apiClient.post('/GetActiveNews', { audience })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read news')
  }
  return response.data.news ?? []
}

export async function addNews({ body, startDate, endDate, audience }) {
  const response = await apiClient.post('/AddNews', {
    body,
    start_date: startDate,
    end_date: endDate,
    audience
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not save the news item')
  }
}

export async function deleteNews(id) {
  const response = await apiClient.post('/DeleteNews', { id })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not delete the news item')
  }
}
